<template>
    <div>
        <template v-if="mode != 'manual'">
            <vx-google-place-search
                v-if="isGoogleSearch"
                v-model="address"
                placeholder="Search addresses and businesses..."
                name="address"
                class="w-full"
                australia-only
                type="address"
                :autofocus="autofocus"
            />
            <vx-addressify-search
                v-else-if="isAddressifySearch"
                v-model="address"
                placeholder="Search addresses..."
                type="address"
                class="w-full"
                :autofocus="autofocus"
                name="address"
            />
            <vs-divider />
        </template>

        <slot name="additional" />

        <vx-input
            v-model="streetAddress1"
            name="street address"
            label="Address Line 1"
            class="w-full"
            :required="required"
            :disabled="disableInputs"
        />
        <vx-input
            v-model="streetAddress2"
            name="street address"
            label="Address Line 2"
            class="w-full"
            :disabled="disableInputs"
        />
        <vx-suburb-suggest
            v-model="suburb"
            type="suburb"
            class="w-full"
            label="Suburb"
            name="suburb"
            :required="required"
            :disabled="disableInputs"
        />
        <div class="flex flex-nowrap gap-4">
            <vx-state-select
                v-model="state"
                name="state"
                label="State"
                class="w-1/3"
                :required="required"
                :disabled="disableInputs"
                value-is-text
            />

            <vx-input
                v-model="postcode"
                v-mask="'####'"
                name="postcode"
                label="Post Code"
                class="w-1/3"
                :required="required"
                :disabled="disableInputs"
            />
            <vx-input
                v-model="country"
                name="country"
                label="Country"
                class="w-1/3"
                :required="required"
                disabled
            />
        </div>
        <vx-checkbox
            v-if="allowManualEntry && !isManualEntryOnly"
            v-model="manualEntry"
            label="Edit Manually"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'vx-address-form',
    props: {
        value: {
            type: Object
        },
        allowManualEntry: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            validate: (v) => ['google', 'addressify', 'manual'].contains(v),
            default: 'google'
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            manualEntry: false,
            defaultAddress: {
                streetAddress1: null,
                streetAddress2: null,
                suburb: null,
                state: null,
                postcode: null,
                country: null
            }
        }
    },
    computed: {
        ...mapGetters({
            getStateByCode: 'crm/getStateByCode',
            getStateById: 'crm/getStateById',
            states: 'crm/states'
        }),
        address: {
            get() {
                return this.value || this.defaultAddress
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        state: {
            get() {
                return this.address.state
            },
            set(v) {
                this.address = {
                    ...this.address,
                    state: v
                }
            }
        },
        postcode: {
            get() {
                return this.address.postcode
            },
            set(v) {
                this.address = {
                    ...this.address,
                    postcode: v
                }
            }
        },
        streetAddress1: {
            get() {
                return this.address.streetAddress1
            },
            set(v) {
                this.address = {
                    ...this.address,
                    streetAddress1: v
                }
            }
        },
        streetAddress2: {
            get() {
                return this.address.streetAddress2
            },
            set(v) {
                this.address = {
                    ...this.address,
                    streetAddress2: v
                }
            }
        },
        suburb: {
            get() {
                return this.address.suburb
            },
            set(v) {
                this.address = {
                    ...this.address,
                    suburb: v
                }
            }
        },
        country: {
            get() {
                return this.address.country || 'Australia'
            },
            set(v) {
                this.address = {
                    ...this.address,
                    country: v
                }
            }
        },
        isAddressSet() {
            return !!this.value
        },
        isAddressifySearch() {
            return this.mode == 'addressify'
        },
        isGoogleSearch() {
            return this.mode == 'google'
        },
        disableInputs() {
            if (this.isManualEntryOnly) {
                return false
            }
            return !this.manualEntry
        },
        isManualEntryOnly() {
            return this.mode == 'manual'
        }
    }
}
</script>

<style>
.vs-select--options {
    border-top-right-radius: 0px !important;
    border-top-left-radius: 5px !important;
}
</style>
